/* global console */
import utils from 'utils/utils';
import PluginModel from 'player/plugins/model';

const Plugins = (function() {
    const plugins = {};
    const pluginsRepo = 'http://localhost:3000/plugins/';

    const PluginsLoader = function(options) {
        // no plugins provided, complete immediately
        if (!options) {
            // timeout for proper event listener fire
            setTimeout(this.trigger.bind(this, 'complete'), 300);
            return;
        }
        const scripts = Object.keys(options);
        let queueLen = scripts.length;

        function onResponse(plugin, status) {
            queueLen -= 1;

            if (status === 'error') {
                // eslint-disable-next-line no-console
                console.error(`An error occur while loading ${plugin}`);
            }
            // plugins are loaded when all requests from batch have been finished
            if (queueLen === 0) {
                this.trigger('complete');
            }
        }

        function getPluginSrc(plugin) {
            if (plugin.indexOf('http') > -1) {
                return plugin;
            }

            return pluginsRepo + plugin;
        }

        utils.each(scripts, function(plugin) {
            const pluginSrc = getPluginSrc(plugin);

            // eslint-disable-next-line new-cap
            const request = new utils.scriptLoader(pluginSrc);

            request.on('complete', onResponse.bind(this, plugin));
            request.on('error', onResponse.bind(this, pluginSrc, 'error'));

            request.load();
        }.bind(this));
    };

    utils.extend(PluginsLoader.prototype, utils.Events);

    return utils.extend({
        register: function(plugin) {
            const name = plugin.getName();

            // register the same plugin only once
            if (!plugins[name]) {
                plugins[name] = PluginModel.extend(plugin);
            }
        },

        load: function(options) {
            return new Promise(function(resolve) {
                const loader = new PluginsLoader(options);
                loader.on('complete', resolve);
            });
        },

        get: function(name) {
            return plugins[name];
        }
    }, utils.Events);
}());

export default Plugins;
